<span
  *ngIf="loading"
  class="pending-survey-badge-shimmer"
>
  <app-shimmer-loader
    [count]="1"
    [appearance]="'circle'"
    [theme]="shimmerTheme"
  ></app-shimmer-loader>
</span>
<span
  *ngIf="!loading && pendingSurveyCount > 0"
  [class.selected]="isSelected"
  class="pending-survey-badge"
>
  {{ pendingSurveyCount }}
</span>

